export default {"src":"/_next/static/image/public/images/ic_delete_red.830401c5da317fb06d71db79a9b86399.svg","height":19,"width":20};